export const noBusinessNodes = ['list','list_item', 'divContainer','list2_item', 'col', 'div', 'list_v2', 'tab']
